import * as React from 'react';

import { parse } from 'papaparse';
import { useAlert } from 'libs/react-alert';
import { Trans } from '@lingui/macro';

import { sessionStore, TFolderCodes, MANUALLY_ADDED_FOLDER, API } from '../../services';
import './upload-button.component.scss';

const INVALID_CODE = 'INVALID_CODE';

export const UploadButton: React.FunctionComponent<{}> = () => {
	let input = React.useRef();
	const alert = useAlert();

	const formatId = (id: string): string => {
		const validLength = 5;
		if (id.length > validLength) return INVALID_CODE;
		if (id.length === validLength) return id;
		const prefixCount = validLength - id.length;

		return `${'0'.repeat(prefixCount)}${id}`;
	};

	const parseCSV = (e: any) => {
		if (!e.target.files[0]) return;
		parse(e.target.files[0], {
			complete: result => {
				if (result.data.length) {
					const folderName = e.target.files[0].name.split('.')[0];
					const codes = (result.data as string[][])
						.filter(([code]) => code.length)
						.map(([code]) => formatId(`${code}`));

					const folders: TFolderCodes = { ...sessionStore.listOfCodes$.value };
					if (folders.hasOwnProperty(folderName)) {
						folders[folderName] = [...folders[folderName], ...codes];
					} else {
						folders[folderName] = [...codes];
					}
					sessionStore.listOfCodes$.next(folders);
				} else {
					alert.show(<Trans>Please check uploaded file. It may be empty or incorrect.</Trans>);
				}
			},
		});
	};

	const checkCode = async (code: string) => {
		return new Promise<boolean>((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.onload = function () {
				if (xhr.status === 200) {
					resolve(true);
				} else {
					reject();
				}
			};
			xhr.onerror = function () {
				alert.error(<Trans>Request error.</Trans>);
			};
			xhr.open('GET', `${API}/${code}.png`);
			xhr.responseType = 'blob';
			xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
			xhr.send();
		});
	};

	const addCode = () => {
		// @ts-ignore
		const code = formatId(input.current.value);
		if (code === INVALID_CODE) {
			alert.error(<Trans>Incorrect code format. The code must contain no more than 4 digits.</Trans>);
			return;
		}
		checkCode(code).then(
			() => {
				const folders: TFolderCodes = { ...sessionStore.listOfCodes$.value };
				if (folders.hasOwnProperty(MANUALLY_ADDED_FOLDER)) {
					folders[MANUALLY_ADDED_FOLDER] = [...folders[MANUALLY_ADDED_FOLDER], code];
				} else {
					folders[MANUALLY_ADDED_FOLDER] = [code];
				}
				sessionStore.listOfCodes$.next(folders);
				// @ts-ignore
				input.current.value = '';
				alert.success(<Trans>Code {code} has been successfully added.</Trans>);
			},
			() => {
				alert.error(<Trans>We can’t find a QR code :(</Trans>);
			},
		);
	};

	return (
		<div className="upload-block">
			<div className="manually-add">
				{/* @ts-ignore */}
				<input ref={input} type="text" />
				<button className="add-button" onClick={() => addCode()}>
					<Trans>Add</Trans>
				</button>
			</div>
			<div>
				<label className="upload-button" htmlFor="file">
					<span>
						<Trans>Upload file</Trans>
					</span>
					<input id="file" type="file" onChange={e => parseCSV(e)} style={{ display: 'none' }} />
				</label>
			</div>
		</div>
	);
};
